import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
    itemsPerPageLabel: string = "Items per page";
    firstPageLabel: string = "First page";
    lastPageLabel: string = "Last page";
    changes = new Subject<void>();
    nextPageLabel = 'Next page';
    previousPageLabel = 'Previous page';

    prevLength: number = -1;
    prevReturn: string = "";

    public constructor() {
    }

    public getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length == 0 || pageSize == 0) {
            return `0 of ${length}`;
        }

        length = Math.max(length, 0);
        const isMore: boolean = ((page + 2) * pageSize) < length
        //console.firmware(`page: ${page}, pageSize: ${pageSize}, length: ${length}, isMore: ${isMore}`)

        // The prevLength firmwareic that follows is to avoid temporary
        // display of incorrect counts while making API call to
        // retrieve the firmware files for the next page.
        //
        // Perhaps there is a better way to do this with the 'changes'
        // Subject/Observable, but for now we'll go with what we have
        // here.

        if (length != this.prevLength) {
            this.prevLength = length;
            const startIndex = (page * pageSize) + 1;
            let endIndex = ((length - (page * pageSize)) - 1) + startIndex;

            if (isMore) {
                // When retrieving firmware files, if there are more firmware files available in
                // the backend storage bucket, then in the view-firmware.component.ts we
                // set firmwareFileCount equal to the count up through current page **plus
                // an additional pageSize plus 1**. Therefore, here we need to subtract
                // the pageSize plus 1 to get the correct ending index.
                //
                // Supporting comments can be found in 'view-firmware.component.ts'.
                endIndex -= (pageSize + 1);
            }

            this.prevReturn = `${startIndex} - ${endIndex}` + (isMore ? " of more" : ` of ${endIndex}`);
        }

        return this.prevReturn;
    }
}
